//MODALS
(function() {

	//Stop backgorund from scrolling
	var noScroll = 'wpk-no-scroll';

	//***********************
	//MODAL AUTO LOAD
	//***********************
	//Find auto modal elements
	var modalAuto = document.getElementsByClassName('wpk-modal auto');
	//If we have auto modals on the page
	if(modalAuto.length > 0) {
		//modalBg.classList.add('open');  
		document.body.classList.add(noScroll);   
		for (var i = 0; i < modalAuto.length; i++) {          
			modalAuto[i].classList.add('open');
			var closeButton = modalAuto[i].querySelector('.modal__close');
			if(closeButton) {
				closeButton.addEventListener('click', function(event) {
					//Find parent modal function
					findAncestor(event.target, '.wpk-modal').classList.add('close'); //Fade out anim
					document.body.classList.remove(noScroll);
				});
			}
		}
		
	}

	//Find parent helper function
	function findAncestor (el, sel) {
		while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
		return el;
	}



	//***********************
	//MODAL BUTTON LOAD
	//***********************
	//Find modal buttons triggers
	var modalButtons = document.getElementsByClassName('wpk-modal-button'); //More than one button
	//If we have buttons on the page
	if(modalButtons.length > 0) {

		//Loop through all modal buttons
		for (var j = 0; j < modalButtons.length; j++) {
			modalButtons[j].addEventListener('click', function() {
				//Get button data attr.
				var target = this.getAttribute('data-target');
				modalOpen(target);
			}, false);
		}
	}

	//Open modal helper function
	function modalOpen(target) {
		var modal = document.getElementById(target);
		if(modal) {
			modal.classList.remove('close', 'open');//Reset for open animation
			modal.classList.add('open');
			document.body.classList.add(noScroll);

			//Close button (child)
			var closeButton = modal.querySelector('.modal__close');
			if(closeButton) {
				closeButton.addEventListener('click', function() {
					modal.classList.add('close'); //Fade out
					document.body.classList.remove(noScroll);
				});
			}
		} else {
			//console.log('No modal found');
			return false;
		}
		
	}

	//***********************
	//HCP
	//***********************

    //HCP Element
    var hcpModal = document.getElementById('modal-hcp');
    
	//If we have the modal
	if(hcpModal) {

		//Parent eventListener for performance
		hcpModal.addEventListener('click', function(event) {

			var target = event.target;

			//Must have a id
			if(target.id) {

				//If click outside buttons, Return false stops from bubbling up
				if( !target.id === 'wpk-hcp-accept-button' || !target.id === 'wpk-hcp-dismiss-button' ) {
					return false;
				}
				//If the child click is a accept
				if ( target.id === 'wpk-hcp-accept-button' ) {
					document.cookie = "wpk_hcp=true; path=/; SameSite=Strict"; //No expire = session cookie
					//var thisPath = window.location.pathname;
					//document.cookie = 'wpk_hcp=true; path='+thisPath+'; SameSite=Strict'; //No expire = session cookie
					hcpModal.classList.add('close'); //Fade out
					document.body.classList.remove(noScroll);
				}
				//If the child click is a dismiss
				if ( target.id === 'wpk-hcp-dismiss-button' ) {
					var hcp_url = event.target.getAttribute('data-url');
					if(hcp_url) {
						//forward user to url
						location.href= hcp_url;
					}
				}

			}

		}, false);
	}
})();